import { render } from "./CommunicationType.vue?vue&type=template&id=59af4666&scoped=true"
import script from "./CommunicationType.vue?vue&type=script&lang=js"
export * from "./CommunicationType.vue?vue&type=script&lang=js"

import "./CommunicationType.vue?vue&type=style&index=0&id=59af4666&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59af4666"]])

export default __exports__